import moment from 'moment';

export default {
	props: {
		context: {
			type: [Object, Array, Boolean],
			required: true,
		},
		options: {
			type: Object,
			required: false,
			default: () => {},
		},
	},

	// executes javascript in v-html, restricted by options (executeScriptSrc)
	methods: {
		executeScript(el) {
			const scripts = el.querySelectorAll('script');
			scripts.forEach(script => {
				if (
					script.src &&
					this.options.executeScriptSrc &&
					this.options.executeScriptSrc.some(src => script.src.startsWith(src))
				) {
					const newScript = document.createElement('script');
					newScript.src = script.src;
					document.body.appendChild(newScript);
				}
			});
		},

		getSbwFormattedOpeningTimes(oeffnungszeiten, titel = 'Öffnungszeiten') {
			let text = '';
			const oezs = oeffnungszeiten.oeffnungszeitenStrukturiert;
			if (oeffnungszeiten != null && oezs != null && oezs.length > 0) {
				oezs.forEach(oz => {
					const abweichendeZeiten = oz.abweichendeZeiten;
					const now = moment();
					if (abweichendeZeiten != null && abweichendeZeiten.length > 0) {
						text += `<div class="font-semibold">Abweichende ${oz.typ}</div>`;
						abweichendeZeiten.forEach(az => {
							const beginn = moment(az.beginn);
							const ende = moment(az.ende);

							if (now.isBetween(beginn, ende)) {
								text += `<div class="mb-3 p-2 bg-secondary-700 text-white">`;
								text += `<div><strong>${beginn.format('DD.MM.YYYY')} - ${ende.format('DD.MM.YYYY')}</strong></div>`;
								text += `<div>${az.zusatz}</div>`;
								text += `</div>`;
							}
						});
					}

					const regulaereZeiten = JSON.parse(
						JSON.stringify(oz.regulaereZeiten),
					);

					// Gruppiere die Einträge nach `tagestyp`
					const groupedByTagestyp = regulaereZeiten.reduce((acc, curr) => {
						if (!acc[curr.tagestyp]) {
							acc[curr.tagestyp] = [];
						}
						acc[curr.tagestyp].push(curr);
						return acc;
					}, {});

					// Fasse die Zeitintervalle zusammen und sortiere sie nach Uhrzeit
					const summarizedTimes = Object.keys(groupedByTagestyp).map(
						tagestyp => {
							const times = groupedByTagestyp[tagestyp]
								.sort((a, b) => moment(a.beginn) - moment(b.beginn))
								.map(item => {
									const beginn = moment(item.beginn).format('HH:mm');
									const ende = moment(item.ende).format('HH:mm');
									return `${beginn} - ${ende}`;
								})
								.join(', ');
							return {
								tagestyp,
								zeiten: `${times} Uhr`,
							};
						},
					);

					// Füge alle Tage von Montag bis Freitag hinzu, wenn sie nicht vorhanden sind
					const allDays = [
						'MONTAG',
						'DIENSTAG',
						'MITTWOCH',
						'DONNERSTAG',
						'FREITAG',
					];

					allDays.forEach(day => {
						if (!summarizedTimes.some(item => item.tagestyp === day)) {
							summarizedTimes.push({tagestyp: day, zeiten: 'geschlossen'});
						}
					});

					// Definiere die Reihenfolge der Wochentage
					const wochentage = [
						'MONTAG',
						'DIENSTAG',
						'MITTWOCH',
						'DONNERSTAG',
						'FREITAG',
						'SAMSTAG',
						'SONNTAG',
					];

					// Sortiere die `summarizedTimes`
					summarizedTimes.sort((a, b) => {
						const indexA = wochentage.indexOf(a.tagestyp);
						const indexB = wochentage.indexOf(b.tagestyp);

						// Alles, was nicht als Wochentag erkannt wird, soll ganz oben stehen
						if (indexA === -1) return -1;
						if (indexB === -1) return 1;

						return indexA - indexB;
					});

					if (summarizedTimes != null && summarizedTimes.length > 0) {
						text += `<div class="mb-3">`;

						if (oz.typ === 'ALLGEMEINE_OEFFNUNGSZEIT') {
							text += `<div class="font-semibold">Allgemeine ${titel}</div>`;
						} else if (oz.typ === 'SERVICEZEIT') {
							text += `<div class="font-semibold">Servicezeit</div>`;
						} else if (oz.typ === 'TELEFONISCHE_ERREICHBARKEIT') {
							text += `<div class="font-semibold">Telefonische Erreichbarkeit</div>`;
						}

						if (oz.hinweisText != null) {
							text += `<div class="font-semibold">${oz.hinweisText}</div>`;
						}

						summarizedTimes.forEach(rz => {
							let tagesTyp = 'Montag bis Samstag';
							if (rz.tagestyp === 'ARBEITSTAG_MO_FR') {
								tagesTyp = 'Montag bis Freitag';
							} else if (rz.tagestyp === 'MONTAG') {
								tagesTyp = 'Montag';
							} else if (rz.tagestyp === 'DIENSTAG') {
								tagesTyp = 'Dienstag';
							} else if (rz.tagestyp === 'MITTWOCH') {
								tagesTyp = 'Mittwoch';
							} else if (rz.tagestyp === 'DONNERSTAG') {
								tagesTyp = 'Donnerstag';
							} else if (rz.tagestyp === 'FREITAG') {
								tagesTyp = 'Freitag';
							} else if (rz.tagestyp === 'SAMSTAG') {
								tagesTyp = 'Samstag';
							} else if (rz.tagestyp === 'SONNTAG') {
								tagesTyp = 'Sonntag';
							}
							text += `<div>${tagesTyp}: ${rz.zeiten}</div>`;
						});

						text += `</div>`;
					}
				});
			}

			return text;
		},
	},

	directives: {
		'execute-script': {
			mounted: function (el, binding) {
				binding.instance.executeScript(el);
			},
		},
	},
};
